import { useMutation } from 'react-query';
import {useWordPressStore} from "../../store/wordpress.store";
import {WordpressApi} from "../../api/wordpress.api";

export const useWordPressPages = () => {
    const setPages = useWordPressStore((state) => state.setPages);

    return useMutation(WordpressApi.getPages, {
        onSuccess: (data) => {
            setPages(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};